import React from "react";
import "react-input-range/lib/css/index.css";

import Utils from "../../helpers/Utils";
import Consts from "../../helpers/Consts";
import DataService from "../../helpers/DataService";
import Category from "../Category/Category";
import noUiSlider from "nouislider";
import wnumb from "wnumb";
import _ from "lodash";
import Lang from "../../helpers/Lang";

class Explorer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      componentOpen: true,
      tabOpen: 0,
      showingCategories: Consts.categories.numberOfElements,
      activeCategory: null,
      categories: [],
      apiErrorCategories: false,
      isDirty: false,
    };

    this.focusRef = React.createRef();
    this.focusRef.current = { focus: -1 };
  }
  theRange = null; //the html object

  _initSlider() {
    this.theRange = document.getElementById("gallery-explore-year-range");

    noUiSlider.create(this.theRange, {
      start: [this.props.minMax.min, this.props.minMax.max], // 4 handles, starting at...
      behaviour: "tap-drag", // Move handle on tap, bar is draggable
      tooltips: true,
      connect: true,
      format: wnumb({
        decimals: 0,
      }),
      range: {
        min: this.props.minMax.min,
        max: this.props.minMax.max,
      },
    });

    // Accessibility
    var handleLower = this.theRange.querySelector(".noUi-handle-lower");
    var handleUpper = this.theRange.querySelector(".noUi-handle-upper");

    var self = this;
    handleLower.addEventListener("keydown", function (e) {
      var value = Number(self.theRange.noUiSlider.get()[0]);
      if (e.which === 37) {
        self.theRange.noUiSlider.set([value - 10, null]);
      }
      if (e.which === 39) {
        self.theRange.noUiSlider.set([value + 10, null]);
      }
    });
    handleUpper.addEventListener("keydown", function (e) {
      var value = Number(self.theRange.noUiSlider.get()[1]);
      if (e.which === 37) {
        self.theRange.noUiSlider.set([null, value - 10]);
      }
      if (e.which === 39) {
        self.theRange.noUiSlider.set([null, value + 10]);
      }
    });
  }

  _resetList = () => {
    this.setState({ activeCategory: null });
    this.props.resetList();
  };

  _toggleTab = (e) => {
    const element = e.target.parentElement;
    const activeTab = Array.from(element.parentNode.children).indexOf(element);
    this.setState({
      tabOpen: activeTab,
    });
    activeTab == 0 &&
      !element.classList.contains("selected") &&
      this._resetList();
    this.props.toggleTab(activeTab);
    e.preventDefault();
  };

  _showMoreCats = () => {
    this.focusRef.current.focus = document.getElementsByClassName(
      "gallery-explorer-category"
    ).length;
    this.setState({
      showingCategories: this.state.categories.length,
    });
  };

  _showLessCats = () => {
    this.focusRef.current.focus = 0;
    this.setState({
      showingCategories: Consts.categories.numberOfElements,
    });
  };

  _search = () => {
    const searchQuery = document.getElementById(
      "gallery-explorer-input-search"
    ).value;
    if (searchQuery.length < Consts.search.minimumNumberOfChars) {
      return false;
    }
    this.props.search(
      searchQuery,
      this.theRange.noUiSlider.get()[0],
      this.theRange.noUiSlider.get()[1],
      Consts.api.numberOfElements,
      0
    );

    this.setState({ isDirty: true });
  };

  _clickCategory = (category) => {
    if (
      this.state.activeCategory &&
      category.category === this.state.activeCategory.category
    ) {
      category = null;
    }
    this.setState({
      activeCategory: category,
    });
    this.props.clickCategory(category, Consts.api.numberOfElements, 0);
  };

  _toggleComponent = (e) => {
    const open = e.target.classList.contains("open");

    this.setState({
      componentOpen: open ? false : true,
    });
  };

  _getCategories = () => {
    DataService.getCategories(
      (jsonData) => {
        let categories = jsonData.docs.map((item) => {
          return {
            image: Utils.image.getUrl(item, 400),
            category: item["artifact.ingress.title"],
            id: item["artifact.uuid"],
            mediaIdentifier: item["artifact.defaultMediaIdentifier"],
          };
        });
        categories = _.sortBy(categories, ["category", "asc"]);
        this.setState({ categories });
      },
      (error) => {
        this.setState({
          apiErrorCategories: true,
        });
        return null;
      }
    );
  };

  _resetSearch = () => {
    document.getElementById("gallery-explorer-input-search").value = "";
    this.theRange.noUiSlider.set([
      this.props.minMax.min,
      this.props.minMax.max,
    ]);
    this.setState({ isDirty: false });
    this._resetList();
  };

  _enterPressed(event) {
    var code = event.keyCode || event.which;
    if (code === 13) {
      event.preventDefault();
      this._search();
      return false;
    }
  }

  UNSAFE_componentWillMount() {
    this._getCategories();
  }
  componentDidMount() {
    this._initSlider();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      activeCategory: nextProps.activeCategory,
      tabOpen: nextProps.activeTab,
    });
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const minMax = nextProps.minMax;
    const currentMinMax = this.theRange.noUiSlider.get();
    if (minMax.min === currentMinMax[0] && minMax.max === currentMinMax[1]) {
      return;
    }
    this.theRange.noUiSlider.updateOptions({
      range: nextProps.minMax,
    });
  }

  componentDidUpdate() {
    const focus = this.focusRef?.current?.focus;
    if (focus > -1) {
      var elements = document.getElementsByClassName(
        "gallery-explorer-category"
      );
      if (elements && elements.length > focus) elements[focus].focus();
      this.focusRef.current.focus = -1;
    }
  }

  render() {
    return (
      <div>
        <div className="big-toggler-trigger">
          <button
            type="button"
            onClick={this._toggleComponent}
            className={
              "reset icon-right" +
              (this.state.componentOpen
                ? " icon-zoom-out open"
                : " icon-zoom-in")
            }
          >
            {this.props.cmsData.exploreText}
          </button>
        </div>
        <div
          className={
            "gallery-explorer" + (this.state.componentOpen ? " open" : "")
          }
        >
          <ul className="tabs">
            <li>
              <a
                href="#"
                className={this.state.tabOpen == 0 ? "selected" : null}
                onClick={this._toggleTab}
              >
                {this.props.cmsData.categoriesText}
              </a>
            </li>
            <li>
              <a
                href="#"
                className={this.state.tabOpen == 1 ? "selected" : null}
                onClick={this._toggleTab}
              >
                {this.props.cmsData.searchText}
              </a>
            </li>
          </ul>

          <div className="gallery-explorer-content">
            <div
              className={
                "gallery-explorer-cat" +
                (this.state.tabOpen == 0 ? " active" : null)
              }
            >
              {this.state.apiErrorCategories ? (
                <h3>{this.props.cmsData.noContactText}</h3>
              ) : (
                <div>
                  <div className="gallery-explorer-categories">
                    {this.state.categories.map((cat, index) => {
                      if (index >= this.state.showingCategories) {
                        return null;
                      } else {
                        let isActive =
                          this.state.activeCategory &&
                          this.state.activeCategory.category === cat.category;
                        return (
                          <Category
                            key={index}
                            clickCategory={this._clickCategory}
                            isActiveCategory={isActive}
                            item={cat}
                          />
                        );
                      }
                    })}
                  </div>

                  <div>
                    {this.state.showingCategories <
                    this.state.categories.length ? (
                      <button className="btn-link" onClick={this._showMoreCats}>
                        {this.props.cmsData.showMoreCategoriesText}
                      </button>
                    ) : null}

                    {this.state.showingCategories ===
                    this.state.categories.length ? (
                      <button className="btn-link" onClick={this._showLessCats}>
                        {this.props.cmsData.showLessCategoriesText}
                      </button>
                    ) : null}
                  </div>
                </div>
              )}
            </div>
            <div
              className={
                "gallery-explorer-search form-area" +
                (this.state.tabOpen == 1 ? " active" : null)
              }
            >
              <div className="row">
                <div className="small-12 medium-5 columns">
                <label htmlFor="gallery-explorer-input-search"
                       className="label-fullwidth">
                    {this.props.cmsData.searchText}
                  </label>
                  <input
                    placeholder={Lang.get("searchPlaceholderMinChars")}
                    type="text"
                    id="gallery-explorer-input-search"
                    onKeyPress={this._enterPressed.bind(this)}
                  />
                </div>
                <div className="small-12 medium-5 columns">
                  <label className="label-fullwidth">
                    {this.props.cmsData.periodText}
                  </label>

                  <div id="gallery-explore-year-range" />
                </div>
                <div className="small-12 medium-2 gallery-explorer-button-wrapper columns">
                  <input
                    type="button"
                    className="button submit"
                    value={this.props.cmsData.searchButtonText}
                    onClick={this._search}
                  />
                </div>
              </div>
              {this.state.isDirty && (
                <div className="row">
                  <div className="small-12 medium-6 columns">
                    <button className="btn-link" onClick={this._resetSearch}>
                      {this.props.cmsData.resetSearchText}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Explorer;
